var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50033 8.58582L12.7428 11.8283L12.0362 12.5358L8.50033 8.99999V3.99999H9.50033V8.58582ZM9.00033 17.3333C4.39783 17.3333 0.666992 13.6025 0.666992 8.99999C0.666992 4.39749 4.39783 0.666656 9.00033 0.666656C13.6028 0.666656 17.3337 4.39749 17.3337 8.99999C17.3337 13.6025 13.6028 17.3333 9.00033 17.3333ZM9.00033 16.3333C10.9452 16.3333 12.8105 15.5607 14.1858 14.1854C15.561 12.8102 16.3337 10.9449 16.3337 8.99999C16.3337 7.05507 15.561 5.18981 14.1858 3.81454C12.8105 2.43927 10.9452 1.66666 9.00033 1.66666C7.0554 1.66666 5.19014 2.43927 3.81488 3.81454C2.43961 5.18981 1.66699 7.05507 1.66699 8.99999C1.66699 10.9449 2.43961 12.8102 3.81488 14.1854C5.19014 15.5607 7.0554 16.3333 9.00033 16.3333Z",
    fill: "#FF474A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingCircle);
export default __webpack_public_path__ + "static/media/pending-circle.d881f0d2864b3989abccc7703a21ea82.svg";
export { ForwardRef as ReactComponent };